import { DocumentType } from '~/api/graphql';
import { type UseCase } from './presets.utils';

export const acordDocumentOptions: Array<{
  documentType: DocumentType;
  title: string;
  useCases?: UseCase[];
  /** Long-form apps omitted from the generate-certificate picker. */
  hiddenForGenerateCertificate?: boolean;
}> = [
  {
    documentType: DocumentType.Acord_1,
    title: 'ACORD 1 (Property Loss Notice)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_2,
    title: 'ACORD 2 (Automobile Loss Notice)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_3,
    title: 'ACORD 3 (General Liability Notice of Occurrence/Claim)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_4,
    title: 'ACORD 4 (Workers Compensation First Report of Injury or Illness)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_20,
    title: 'ACORD 20 (Certificate of Aviation Liability Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_21,
    title: 'ACORD 21 (Certificate of Aircraft Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_22,
    title: 'ACORD 22 (Intermodal Interchange Certificate of Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_23,
    title: 'ACORD 23 (Vehicle or Equipment Certificate of Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_24,
    title: 'ACORD 24 (Certificate of Property Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_25,
    title: 'ACORD 25 (Certificate of Liability Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_27,
    title: 'ACORD 27 (Evidence of Property Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_28,
    title: 'ACORD 28 (Evidence of Commercial Property Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_29,
    title: 'ACORD 29 (Evidence of Flood Insurance)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_30,
    title: 'ACORD 30 (Certificate of Insurance, Garage)',
    useCases: ['fill_acord_form', 'generate_certificate']
  },
  {
    documentType: DocumentType.Acord_35,
    title: 'ACORD 35 (Lost Policy Release / Cancellation Request)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_36,
    title: 'ACORD 36 (Agent / Broker Change of Record)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_37,
    title: 'ACORD 37 (Statement of No Loss)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_50,
    title: 'ACORD 50 (Identification Card)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Al,
    title: 'ACORD 50 AL (Identification Card, Alabama)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ar,
    title: 'ACORD 50 AR (Identification Card, Arkansas)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Az,
    title: 'ACORD 50 AZ (Identification Card, Arizona)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ca,
    title: 'ACORD 50 CA (Identification Card, California)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Co,
    title: 'ACORD 50 CO (Identification Card, Colorado)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ct,
    title: 'ACORD 50 CT (Identification Card, Connecticut)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Fl,
    title: 'ACORD 50 FL (Identification Card, Florida)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ga,
    title: 'ACORD 50 GA (Identification Card, Georgia)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Hi,
    title: 'ACORD 50 HI (Identification Card, Hawaii)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ia,
    title: 'ACORD 50 IA (Identification Card, Iowa)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Id,
    title: 'ACORD 50 ID (Identification Card, Idaho)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Il,
    title: 'ACORD 50 IL (Identification Card, Illinois)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50In,
    title: 'ACORD 50 IN (Identification Card, Indiana)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ky,
    title: 'ACORD 50 KY (Identification Card, Kentucky)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50La,
    title: 'ACORD 50 LA (Identification Card, Louisiana)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Md,
    title: 'ACORD 50 MD (Identification Card, Maryland)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Me,
    title: 'ACORD 50 ME (Identification Card, Maine)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Mi,
    title: 'ACORD 50 MI (Identification Card, Michigan)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Mo,
    title: 'ACORD 50 MO (Identification Card, Missouri)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ms,
    title: 'ACORD 50 MS (Identification Card, Mississippi)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Nd,
    title: 'ACORD 50 ND (Identification Card, North Dakota)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ne,
    title: 'ACORD 50 NE (Identification Card, Nebraska)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Nj,
    title: 'ACORD 50 NJ (Identification Card, New Jersey)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Ok,
    title: 'ACORD 50 OK (Identification Card, Oklahoma)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Pa,
    title: 'ACORD 50 PA (Identification Card, Pennsylvania)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  // ACORD 50 NJ SET and PA SET (multi-copy sheets) are omitted: offering them
  // next to the regular NJ and PA cards made it unclear which form a request
  // produces. The backend templates stay wired; do not add them back to the
  // picker until the product wants that printing choice.
  {
    documentType: DocumentType.Acord_50Ri,
    title: 'ACORD 50 RI (Identification Card, Rhode Island)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Sc,
    title: 'ACORD 50 SC (Identification Card, South Carolina)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Sd,
    title: 'ACORD 50 SD (Identification Card, South Dakota)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Tn,
    title: 'ACORD 50 TN (Identification Card, Tennessee)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Tx,
    title: 'ACORD 50 TX (Identification Card, Texas)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Vt,
    title: 'ACORD 50 VT (Identification Card, Vermont)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_50Wv,
    title: 'ACORD 50 WV (Identification Card, West Virginia)',
    useCases: ['fill_acord_form', 'generate_id_cards']
  },
  {
    documentType: DocumentType.Acord_70,
    title: 'ACORD 70 (Personal Policy Change Request)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_71,
    title: 'ACORD 71 (Personal Auto Policy Change Request)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_75,
    title: 'ACORD 75 (Insurance Binder)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_80,
    title: 'ACORD 80 (Homeowners Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_81,
    title: 'ACORD 81 (Personal Inland Marine Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_82,
    title: 'ACORD 82 (Watercraft Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_83,
    title: 'ACORD 83 (Personal Umbrella Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_84,
    title: 'ACORD 84 (Dwelling Fire Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_88,
    title: 'ACORD 88 (Personal Insurance Application - Information Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_89,
    title: 'ACORD 89 (Residential Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_89Ca,
    title: 'ACORD 89 (Residential Section, California)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_89Nv,
    title: 'ACORD 89 (Residential Section, Nevada)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_89Ny,
    title: 'ACORD 89 (Residential Section, New York)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ak,
    title: 'ACORD 90 (Personal Auto, Alaska)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Al,
    title: 'ACORD 90 (Personal Auto, Alabama)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ar,
    title: 'ACORD 90 (Personal Auto, Arkansas)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Az,
    title: 'ACORD 90 (Personal Auto, Arizona)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ca,
    title: 'ACORD 90 (Personal Auto, California)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Co,
    title: 'ACORD 90 (Personal Auto, Colorado)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ct,
    title: 'ACORD 90 (Personal Auto, Connecticut)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Dc,
    title: 'ACORD 90 (Personal Auto, District of Columbia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90De,
    title: 'ACORD 90 (Personal Auto, Delaware)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Fl,
    title: 'ACORD 90 (Personal Auto, Florida)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ga,
    title: 'ACORD 90 (Personal Auto, Georgia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Hi,
    title: 'ACORD 90 (Personal Auto, Hawaii)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ia,
    title: 'ACORD 90 (Personal Auto, Iowa)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Id,
    title: 'ACORD 90 (Personal Auto, Idaho)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Il,
    title: 'ACORD 90 (Personal Auto, Illinois)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90In,
    title: 'ACORD 90 (Personal Auto, Indiana)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ks,
    title: 'ACORD 90 (Personal Auto, Kansas)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ky,
    title: 'ACORD 90 (Personal Auto, Kentucky)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90La,
    title: 'ACORD 90 (Personal Auto, Louisiana)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ma,
    title: 'ACORD 90 (Personal Auto, Massachusetts)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Md,
    title: 'ACORD 90 (Personal Auto, Maryland)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Me,
    title: 'ACORD 90 (Personal Auto, Maine)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Mi,
    title: 'ACORD 90 (Personal Auto, Michigan)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Mn,
    title: 'ACORD 90 (Personal Auto, Minnesota)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Mo,
    title: 'ACORD 90 (Personal Auto, Missouri)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ms,
    title: 'ACORD 90 (Personal Auto, Mississippi)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Mt,
    title: 'ACORD 90 (Personal Auto, Montana)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Nc,
    title: 'ACORD 90 (Personal Auto, North Carolina)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Nd,
    title: 'ACORD 90 (Personal Auto, North Dakota)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ne,
    title: 'ACORD 90 (Personal Auto, Nebraska)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Nh,
    title: 'ACORD 90 (Personal Auto, New Hampshire)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Nj,
    title: 'ACORD 90 (Personal Auto, New Jersey)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Nm,
    title: 'ACORD 90 (Personal Auto, New Mexico)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Nv,
    title: 'ACORD 90 (Personal Auto, Nevada)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ny,
    title: 'ACORD 90 (Personal Auto, New York)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Oh,
    title: 'ACORD 90 (Personal Auto, Ohio)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ok,
    title: 'ACORD 90 (Personal Auto, Oklahoma)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Or,
    title: 'ACORD 90 (Personal Auto, Oregon)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Pa,
    title: 'ACORD 90 (Personal Auto, Pennsylvania)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ri,
    title: 'ACORD 90 (Personal Auto, Rhode Island)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Sc,
    title: 'ACORD 90 (Personal Auto, South Carolina)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Sd,
    title: 'ACORD 90 (Personal Auto, South Dakota)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Tn,
    title: 'ACORD 90 (Personal Auto, Tennessee)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Tx,
    title: 'ACORD 90 (Personal Auto, Texas)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Ut,
    title: 'ACORD 90 (Personal Auto, Utah)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Va,
    title: 'ACORD 90 (Personal Auto, Virginia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Vt,
    title: 'ACORD 90 (Personal Auto, Vermont)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Wa,
    title: 'ACORD 90 (Personal Auto, Washington)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Wi,
    title: 'ACORD 90 (Personal Auto, Wisconsin)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Wv,
    title: 'ACORD 90 (Personal Auto, West Virginia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_90Wy,
    title: 'ACORD 90 (Personal Auto, Wyoming)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_125,
    title: 'ACORD 125 (Commercial Insurance Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_126,
    title: 'ACORD 126 (Commercial General Liability)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_127,
    title: 'ACORD 127 (Commercial Auto)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_128,
    title: 'ACORD 128 (Garage and Dealers)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  // ACORD 129 (Vehicle Schedule) is omitted: it is a continuation sheet that
  // parent commercial auto forms append when vehicles overflow the base page.
  // The backend template stays wired; do not add this form back to the picker.
  {
    documentType: DocumentType.Acord_130,
    title: "ACORD 130 (Workers' Compensation)",
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_131,
    title: 'ACORD 131 (Excess/Umbrella Liability)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_132,
    title: 'ACORD 132 (Truckers / Motor Carriers)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_133,
    title: 'ACORD 133 (Workers Compensation Assigned Risk)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Al,
    title: 'ACORD 137 (Commercial Auto, Alabama)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ar,
    title: 'ACORD 137 (Commercial Auto, Arkansas)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Az,
    title: 'ACORD 137 (Commercial Auto, Arizona)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ca,
    title: 'ACORD 137 (Commercial Auto, California)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Co,
    title: 'ACORD 137 (Commercial Auto, Colorado)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ct,
    title: 'ACORD 137 (Commercial Auto, Connecticut)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137De,
    title: 'ACORD 137 (Commercial Auto, Delaware)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Fl,
    title: 'ACORD 137 (Commercial Auto, Florida)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ga,
    title: 'ACORD 137 (Commercial Auto, Georgia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ia,
    title: 'ACORD 137 (Commercial Auto, Iowa)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Id,
    title: 'ACORD 137 (Commercial Auto, Idaho)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Il,
    title: 'ACORD 137 (Commercial Auto, Illinois)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137In,
    title: 'ACORD 137 (Commercial Auto, Indiana)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ks,
    title: 'ACORD 137 (Commercial Auto, Kansas)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ky,
    title: 'ACORD 137 (Commercial Auto, Kentucky)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137La,
    title: 'ACORD 137 (Commercial Auto, Louisiana)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ma,
    title: 'ACORD 137 (Commercial Auto, Massachusetts)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Md,
    title: 'ACORD 137 (Commercial Auto, Maryland)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Me,
    title: 'ACORD 137 (Commercial Auto, Maine)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Mi,
    title: 'ACORD 137 (Commercial Auto, Michigan)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Mn,
    title: 'ACORD 137 (Commercial Auto, Minnesota)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Mo,
    title: 'ACORD 137 (Commercial Auto, Missouri)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ms,
    title: 'ACORD 137 (Commercial Auto, Mississippi)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Mt,
    title: 'ACORD 137 (Commercial Auto, Montana)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Nc,
    title: 'ACORD 137 (Commercial Auto, North Carolina)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Nd,
    title: 'ACORD 137 (Commercial Auto, North Dakota)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ne,
    title: 'ACORD 137 (Commercial Auto, Nebraska)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Nh,
    title: 'ACORD 137 (Commercial Auto, New Hampshire)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Nj,
    title: 'ACORD 137 (Commercial Auto, New Jersey)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Nm,
    title: 'ACORD 137 (Commercial Auto, New Mexico)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Nv,
    title: 'ACORD 137 (Commercial Auto, Nevada)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ny,
    title: 'ACORD 137 (Commercial Auto, New York)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Oh,
    title: 'ACORD 137 (Commercial Auto, Ohio)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ok,
    title: 'ACORD 137 (Commercial Auto, Oklahoma)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Or,
    title: 'ACORD 137 (Commercial Auto, Oregon)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Pa,
    title: 'ACORD 137 (Commercial Auto, Pennsylvania)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ri,
    title: 'ACORD 137 (Commercial Auto, Rhode Island)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Sc,
    title: 'ACORD 137 (Commercial Auto, South Carolina)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Sd,
    title: 'ACORD 137 (Commercial Auto, South Dakota)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Tn,
    title: 'ACORD 137 (Commercial Auto, Tennessee)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Tx,
    title: 'ACORD 137 (Commercial Auto, Texas)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Ut,
    title: 'ACORD 137 (Commercial Auto, Utah)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Va,
    title: 'ACORD 137 (Commercial Auto, Virginia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Vt,
    title: 'ACORD 137 (Commercial Auto, Vermont)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Wa,
    title: 'ACORD 137 (Commercial Auto, Washington)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Wi,
    title: 'ACORD 137 (Commercial Auto, Wisconsin)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Wv,
    title: 'ACORD 137 (Commercial Auto, West Virginia)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_137Wy,
    title: 'ACORD 137 (Commercial Auto, Wyoming)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_140,
    title: 'ACORD 140 (Commercial Property)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_141,
    title: 'ACORD 141 (Crime Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_143,
    title: 'ACORD 143 (Transportation Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_144,
    title: 'ACORD 144 (Glass and Sign Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_145,
    title: 'ACORD 145 (Accounts Receivable / Valuable Papers)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_146,
    title: 'ACORD 146 (Equipment Floater Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_147,
    title: "ACORD 147 (Installation / Builder's Risk)",
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_148,
    title: 'ACORD 148 (Electronic Data Processing)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_149,
    title: 'ACORD 149 (Dealers Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_152,
    title: 'ACORD 152 (Commercial Inland Marine Section)',
    useCases: ['fill_acord_form']
  },
  {
    documentType: DocumentType.Acord_155,
    title: 'ACORD 155 (Equipment Breakdown Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_160,
    title: 'ACORD 160 (Business Owners Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_175,
    title: 'ACORD 175 (Commercial Policy Change Request)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_180,
    title: 'ACORD 180 (Technology E&O Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_185,
    title: 'ACORD 185 (Restaurant / Tavern Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_186,
    title: 'ACORD 186 (Contractors Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_187,
    title: 'ACORD 187 (Professional Liability Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_193,
    title: 'ACORD 193 (Open Cargo Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_195,
    title: "ACORD 195 (Design Professional's Individual Property Survey)",
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_196,
    title: 'ACORD 196 (Medical Professional Liability)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_210,
    title: 'ACORD 210 (Yacht Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_281,
    title: 'ACORD 281 (Personal Inland Marine Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_282,
    title: 'ACORD 282 (Watercraft Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_283,
    title: 'ACORD 283 (Personal Umbrella Application Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_285,
    title: 'ACORD 285 (Commercial Marine Insurance Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_301,
    title: 'ACORD 301 (Flood Insurance Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_302,
    title: 'ACORD 302 (Flood Insurance General Change Endorsement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_303,
    title: 'ACORD 303 (Flood Insurance Preferred Risk Policy Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_304,
    title: 'ACORD 304 (Flood Insurance Cancellation / Nullification)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  // ACORD 305 (Flood Insurance Credit Card Payment Form) is omitted: we are
  // not collecting payment information at this time. The backend template
  // stays wired; do not add this form back to the picker or the model's
  // catalog until that changes.
  {
    documentType: DocumentType.Acord_306,
    title: 'ACORD 306 (Flood Insurance Rating Information and Elevated Building Determination)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_307,
    title: 'ACORD 307 (Floodproofing Certificate for Non-Residential Structures)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_308,
    title: 'ACORD 308 (Residential Basement Floodproofing Certificate)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_401,
    title: 'ACORD 401 (Agriculture Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_402,
    title: 'ACORD 402 (Agriculture Property Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_403,
    title: 'ACORD 403 (Agriculture Farm Personal Property)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_404,
    title: 'ACORD 404 (Agriculture Liability Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_406,
    title: 'ACORD 406 (Agriculture Unscheduled Farm Personal Property Inventory)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_410,
    title: 'ACORD 410 (Small Farm / Ranch Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_501,
    title: 'ACORD 501 (Surety Report of Execution)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_502,
    title: 'ACORD 502 (Contract Bond Request Form)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_503,
    title: 'ACORD 503 (Commercial or Miscellaneous Bond Request Form)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_611,
    title: 'ACORD 611 (Claims History / Loss Run Request)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_801,
    title: 'ACORD 801 (Railroad Protective Liability Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_802,
    title: 'ACORD 802 (Hotel / Motel Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_803,
    title: 'ACORD 803 (Liquor Liability Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_807,
    title: 'ACORD 807 (Directors & Officers Liability Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_810,
    title: 'ACORD 810 (Business Income / Extra Expense / Rental Value)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_811,
    title: 'ACORD 811 (Value Reporting Information)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_815,
    title: 'ACORD 815 (International Liability Exposure Supplement)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_825,
    title: 'ACORD 825 (Professional / Specialty Insurance Application)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_827,
    title: 'ACORD 827 (Employment Practices Liability Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_828,
    title: 'ACORD 828 (Fiduciary Liability Coverage Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_830,
    title: 'ACORD 830 (Property Insurance Card)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_832,
    title: 'ACORD 832 (Miscellaneous E&O Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_833,
    title: 'ACORD 833 (Lawyers Professional Liability Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_834,
    title: 'ACORD 834 (Cyber and Privacy Coverage Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  },
  {
    documentType: DocumentType.Acord_838,
    title: 'ACORD 838 (Accountants Professional Liability Section)',
    useCases: ['fill_acord_form'],
    hiddenForGenerateCertificate: true
  }
];
